import { PrimaryButton, Stack, TextField } from "@fluentui/react";
import React, { useMemo } from "react";
import { localize } from "src/l10n";
import { FormControl } from "src/ui/components/Forms";
import { validateRequiredTextField } from "src/utils";
import "./AcademySessionBlockForm.scss";

export interface IAcademySessionBlockContent {
    blockKey: string;
    title: string;
    description: string;
}

interface IProps {
    content: IAcademySessionBlockContent;
    onUpdate: (content: IAcademySessionBlockContent) => void;
    onSave: () => void;
}

const AcademySessionBlockForm = (props: IProps) => {
    const { content, onUpdate } = props;

    const canSave = useMemo(
        () => !!content.title && content.title.trim().length > 0,
        [content.title]
    );

    return (
        <div className="AcademySessionBlockForm">
            <FormControl>
                <TextField
                    className="textField"
                    label={localize("Rubrik")}
                    value={content.title || ""}
                    onChange={(_ev, value) => onUpdate({ ...content, title: value })}
                    maxLength={128}
                    required
                    aria-required
                    validateOnFocusIn
                    validateOnFocusOut
                    onGetErrorMessage={validateRequiredTextField}
                />
            </FormControl>
            <FormControl>
                <TextField
                    className="textField"
                    label={localize("Beskrivning")}
                    value={content.description || ""}
                    onChange={(_ev, value) => onUpdate({ ...content, description: value })}
                    multiline
                    autoAdjustHeight
                    resizable={false}
                />
            </FormControl>
            <Stack horizontal horizontalAlign="end">
                <PrimaryButton
                    text={localize("Spara")}
                    disabled={!canSave}
                    onClick={props.onSave}
                />
            </Stack>
        </div>
    );
};

export default AcademySessionBlockForm;
